// extracted by mini-css-extract-plugin
module.exports = {"container":"app-store-alert-module__container___KlW7w","link":"app-store-alert-module__link___Frhmx"};